import { AddContextualData } from '@opendoor/observability';

import { ShowingRequestCreation } from 'buying/routes/ShowingRequestCreation';

import { RouteComponentOutput } from 'shared/helpers/routes';

export default function ShowingRequestCreationRoute(): RouteComponentOutput {
  return (
    <AddContextualData data={{ topLevelRoute: 'buyer-tour' }}>
      <ShowingRequestCreation />
    </AddContextualData>
  );
}
